import VideoComponent from './VideoComponent';
import createVideoPlugin from '@draft-js-plugins/video';
import { composeDecorators } from '@draft-js-plugins/editor';
import { blockDndPlugin } from '../move-block/move-block';
import { focusPlugin } from '../focus/focus';
import { alignmentPlugin } from '../alignment/alignment';
import styles from './video.module.less';

const decorator = composeDecorators(alignmentPlugin.decorator, focusPlugin.decorator, blockDndPlugin.decorator);
export const videoPlugin = createVideoPlugin({
    theme: {
        iframeContainer: styles.iframeContainer,
        iframe: styles.iframe,
    },
    decorator: decorator,
    videoComponent: VideoComponent,
});
